import React from 'react';
import { DetailText, FlexRow } from '@minecraft.atoms';
import Button, { ButtonProps } from '@minecraft.button';
import Icon from '@minecraft.icon';
import { BaseDropdownButton } from './BaseDropdownButton';
import { DropdownItemProps, OptionalProps } from './types';

const FilterButton = ({ label, selectedCount, ...props }: ButtonProps & { label: string; selectedCount: number }) => {
  const isOpen = props?.['aria-expanded'];
  const iconName = isOpen ? 'chevron-open-thin' : 'chevron-closed-thin';

  return (
    <Button {...props} isSecondary={!isOpen} noPadding fixedWidth={false} color={!isOpen ? 'additional' : 'primary'}>
      <FlexRow
        bgColor={isOpen ? 'primaryActive' : 'transparent'}
        wrap="nowrap"
        gap="2"
        grow={0}
        shrink={0}
        alignItems="center"
        className="cn_relative cn_atom_px-2"
        h="full"
      >
        {label}
        {typeof selectedCount === 'number' && selectedCount > 0 && (
          <FlexRow
            grow={0}
            shrink={0}
            bgColor={isOpen ? 'card' : 'primaryActive'}
            textColor={isOpen ? 'primary' : 'inverted'}
            borderRadius="xl"
            className="cn_atom_px-2 cn_atom_py-1"
            alignItems="center"
            data-testid="count-pill"
          >
            <DetailText fontWeight="semibold" lineHeight="ultraCondensed" color="inherit">
              {selectedCount}
            </DetailText>
          </FlexRow>
        )}
        <Icon name={iconName} size="ssm" inheritColor />
      </FlexRow>
    </Button>
  );
};

export interface FilterDropdownButtonProps extends OptionalProps {
  toggleLabel: string;
  selectedCount: number;
  toggleProps?: Partial<Omit<ButtonProps, 'children' | 'qaId' | 'testId'>>;
  menuChildren?: React.ReactNode;
  menuItemsProps?: DropdownItemProps[];
  menuAlign?: 'right' | 'left';
  block?: boolean;
  mobileBlock?: boolean;
  disabled?: boolean;
}

export const FilterDropdownButton = ({
  toggleProps = {},
  toggleLabel,
  selectedCount,
  menuAlign = 'right',
  menuChildren,
  menuItemsProps = [],
  block = false,
  mobileBlock = false,
  'data-testid': dataTestId,
  qaId,
  className,
  disabled = false,
}: FilterDropdownButtonProps) => (
  <BaseDropdownButton
    block={block}
    className={className}
    data-testid={dataTestId}
    menuAlign={menuAlign}
    menuItemsProps={menuItemsProps}
    menuChildren={menuChildren}
    mobileBlock={mobileBlock}
    qaId={qaId}
    showCaret={false}
    ToggleComponent={FilterButton}
    toggleProps={{ ...toggleProps, label: toggleLabel, selectedCount, disabled }}
  />
);
